import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/authentication/services/auth.service';

@Component({
  selector: 'app-silent-logout',
  templateUrl: './silent-logout.component.html',
  styleUrls: ['./silent-logout.component.scss']
})
export class SilentLogoutComponent implements OnInit {

  constructor(private authService: AuthService) {}

  ngOnInit() {
    try {
      this.authService.removeId();
      this.authService.removeToken();
      localStorage.removeItem('CSRF');
    } finally {
      // 🔔 Notify parent window that silent logout is complete
      window.parent.postMessage(
        'SILENT_LOGOUT_DONE',
        '*' // 🔐 replace with parent origin in production
      );
    }
  }
}
